import { GHLLanguageKeys as o } from "./ghl-ui.es285.js";
import t from "./ghl-ui.es1283.js";
const a = {
  name: o.portuguesePortugal,
  locale: t
};
export {
  a as date_pt_PT
};
